import { ApiResponse } from "../../apiResponse";
import Axios from "../../axios";

export function updateCandidateQualification(
  candidateId: number | string,
  isQualified: boolean,
  pages: number | string | undefined | null
): Promise<ApiResponse> {
  return Axios.put(
    `/v1/tutors/candidates/${candidateId}/candidate_qualification`,
    {
      is_qualified: isQualified,
      end_page_number: pages,
    }
  );
}
